(() => {
  const slugify = (value) => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  const init = (report) => {
    const prose = report.querySelector('[data-cs-grower-report-prose]');
    const lists = report.querySelectorAll('[data-cs-grower-report-toc-list]');
    if (!prose || !lists.length) return;

    const headings = Array.from(prose.querySelectorAll('h2'));
    if (!headings.length) {
      report.querySelectorAll('.cs-grower-report__toc-mobile, .cs-grower-report__toc-desktop')
        .forEach((element) => element.hidden = true);
      return;
    }

    const usedIds = new Set();
    headings.forEach((heading, index) => {
      const base = heading.id || slugify(heading.textContent) || `abschnitt-${index + 1}`;
      let candidate = base;
      let suffix = 2;
      while (usedIds.has(candidate) || (document.getElementById(candidate) && document.getElementById(candidate) !== heading)) {
        candidate = `${base}-${suffix}`;
        suffix += 1;
      }
      heading.id = candidate;
      usedIds.add(candidate);
    });

    lists.forEach((list) => {
      const fragment = document.createDocumentFragment();
      headings.forEach((heading) => {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        item.appendChild(link);
        fragment.appendChild(item);
      });
      list.replaceChildren(fragment);
    });

    if (!('IntersectionObserver' in window)) return;
    const links = Array.from(report.querySelectorAll('[data-cs-grower-report-toc-list] a'));
    const activate = (id) => {
      links.forEach((link) => {
        const active = link.getAttribute('href') === `#${id}`;
        link.classList.toggle('is-active', active);
        if (active) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    };
    const observer = new IntersectionObserver((entries) => {
      const visible = entries
        .filter((entry) => entry.isIntersecting)
        .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
      if (visible[0]) activate(visible[0].target.id);
    }, { rootMargin: '-18% 0px -68% 0px', threshold: 0 });
    headings.forEach((heading) => observer.observe(heading));
  };

  const start = () => document.querySelectorAll('[data-cs-grower-report]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
